//
// Este archivo define la aplicación Stimulus.
// Asegúrate de que su contenido sea este.

import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configura Stimulus para el entorno de desarrollo
application.debug = false
window.Stimulus   = application

export { application }